export default __webpack_public_path__ + "static/media/5.3b98c175.png";